
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Login",
      function () {
        return require("private-next-pages/Login/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Login"])
      });
    }
  